import { Modal } from "antd";
import LabeledInput from "../ui/LabeledInput";

const AddAdminModal = ({ visible, onCancel, onSubmit, formData, setFormData }) => {
  
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Modal
      title="Add New Admin"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText="Submit"
      width={700} 
    >
      <div className="space-y-4">
        {/* Two per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <LabeledInput
          label="First Name"
          value={formData.firstname}
          onChange={(e) => handleChange("firstname", e.target.value)}
          />
          <LabeledInput
            label="Last Name"
            value={formData.lastname}
            onChange={(e) => handleChange("lastname", e.target.value)}
          />
          <LabeledInput
            label="Email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
           <LabeledInput
            label="Mobile"
            value={formData.mobile}
            onChange={(e) => handleChange("mobile", e.target.value)}
          />
    
          <LabeledInput
          label="Password"
          value={formData.password}
          onChange={(e) => handleChange("password", e.target.value)}
        />
          <LabeledInput
          label="Confirm Password"
          value={formData.confirmpassword}
          onChange={(e) => handleChange("confirmpassword", e.target.value)}
        />
        </div>
      </div>
    </Modal>
  );
};

export default AddAdminModal;
